module.exports = __webpack_public_path__ + "static/media/_backslash.ec05e20b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_backslash.jpg
// module id = 66
// module chunks = 0